export const clickListener = (attrib:string, callback: (e:Event)=>void): void => {
    const elements = document.querySelectorAll(`[${attrib}]`);
    elements.forEach((element) => {
        element.addEventListener('click', (e) => {
            callback(e);
        }, true);
    })
}